import { render, staticRenderFns } from "./RoundBlockingComponent.vue?vue&type=template&id=f4bdc622"
import script from "./RoundBlockingComponent.vue?vue&type=script&lang=js"
export * from "./RoundBlockingComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports